import { VcpService } from "src/app/services/vcp.service";
import {
  Component,
  Input,
  OnInit,
  DoCheck,
  Output,
  EventEmitter,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { Status } from "../../entities/status";
import { UnidadeProdutiva } from "../../entities/unidade-produtiva";
import { Step } from "../../shared/multi-steps/multi-steps.component";
import { UpCertificacaoService } from "src/app/services/up-certificacao.service";
import { ModalService } from "src/app/services/modal.service";
import { SubscriptionService } from "src/app/services/subscription.service";
import { finalize } from "rxjs/operators";
import { PermissionService } from "src/app/services/permission-service";
import { PerfilUsuario } from "src/app/entities/perfil";
import { EtapaABR } from "src/app/entities/etapas";

@Component({
  selector: "modal-certificadora",
  templateUrl: "./modal-certificadora.component.html",
  styleUrls: ["./modal-certificadora.component.scss"],
})
export class ModalCertificadoraComponent implements OnInit, DoCheck, OnDestroy {
  @Input() unidadeProdutiva: UnidadeProdutiva;
  @Input() safraId: number;
  @Input() perfilUsuario: string;

  @Input() esconderAndamentoCertificacao: boolean = false;

  @Output() etapaTrocada = new EventEmitter();

  @ViewChild("modalConvite") modalConvite;
  @ViewChild("modalAceiteConvite") modalAceiteConvite;

  status: Status;
  statusCertificacao: Status;

  convidado: boolean = false;
  loading = false;
  loadingVCP = true;
  loadingCertificacao = true;

  steps: Step[];
  defaultActiveStepLabel: string;
  activeStepLabel: string;

  modalAberto = false;

  etapaCertificadoAbr = false;
  etapaAbr: "Convite" | "VCP" | "Certificado ABR" = "Convite";

  showAndamentoCertificacao = false;

  constructor(
    private permissionService: PermissionService,
    private vcpService: VcpService,
    private upCertificacaoService: UpCertificacaoService,
    private modalService: ModalService,
    private subscriptionService: SubscriptionService
  ) {}

  ngOnInit(): void {}

  ngDoCheck(): void {
    this.loading = this.loadingVCP && this.loadingCertificacao;
  }

  ngOnDestroy(): void {
    this._desmontar();
  }

  _inicializar() {
    this._carregarDefaultActiveStep();
    this._carregarStatusVCP();
    this._carregaStatusCertificacao();
  }

  private _desmontar() {
    this.subscriptionService.unsubscribeAll();
  }

  private _carregarDefaultActiveStep() {
    const defaultActiveStep$ = this.modalService
      .getDefaultActiveStepLabel()
      .subscribe((novoValor) => {
        return this.initActiveStepLabel(novoValor);
      });

    this.subscriptionService.add(defaultActiveStep$);
  }

  initActiveStepLabel(novoValor: string) {
    if (novoValor == null || novoValor == undefined || novoValor == "") {
      this.activeStepLabel = "Convite";
    } else {
      this.activeStepLabel = novoValor;
    }
  }

  private _carregarStatusVCP() {
    this.loadingVCP = true;
    const vcpService$ = this.vcpService
      .getStatusSafraSelecionada(this.unidadeProdutiva)
      .pipe(finalize(() => (this.loadingVCP = false)))
      .subscribe((status) => {
        console.log({ status });
        this.status = status;
      });
    this.subscriptionService.add(vcpService$);
  }

  private _carregaStatusCertificacao() {
    this.loadingCertificacao = true;
    const upCertificacao$ = this.upCertificacaoService
      .getStatusCertificacao(this.unidadeProdutiva)
      .pipe(finalize(() => (this.loadingCertificacao = false)))
      .subscribe((status) => {
        this.statusCertificacao = status;
        this._defineSteps();
      });
    this.subscriptionService.add(upCertificacao$);
  }

  private _defineSteps() {
    let perfil = this.permissionService.getPerfisValidos();
    this.steps = [
      {
        label: "Convite",
        active: true,
      },
      {
        label: "VCP",
        active: this.podeVerEtapaVcp(),
      },
    ];
    if (!perfil.some((x) => x == PerfilUsuario.CERTIFICADORA_AUDITOR)) {
      this.steps.push({
        label: "Certificado ABR",
        active: this.podeVerEtapaCertificacao(),
      });
    }

    this._defineDefaultActiveStep();
  }

  podeVerEtapaVcp() {
    return (
      this.unidadeProdutiva.etapaAbr !== EtapaABR.ESPERANDO_ENVIO_CONVITE ||
      this.status.etapa.toUpperCase().includes("VCP") ||
      this.unidadeProdutiva.etapaAbr.toUpperCase().includes("VDP") ||
      this.unidadeProdutiva.etapaAbr.toUpperCase().includes("PCNC") ||
      this.unidadeProdutiva.etapaAbr.toUpperCase().includes("VCP") ||
      this.unidadeProdutiva.etapaAbr.toUpperCase().includes("CERTIFICA") ||
      this.unidadeProdutiva.etapaAbr.toUpperCase().includes("RETORNO DE ETAPA")
    );
  }

  podeVerEtapaCertificacao() {
    return (
      this.statusCertificacao.etapa.includes("Certificada ABR") ||
      this.statusCertificacao.etapa.toLowerCase().includes("certificação") ||
      this.statusCertificacao.etapa.includes("Certificado")
    );
  }

  private _defineDefaultActiveStep() {
    if (this.podeVerEtapaCertificacao()) {
      return this._changeDefaultActiveStep("Certificado ABR");
    }
    if (this.podeVerEtapaVcp()) {
      return this._changeDefaultActiveStep("VCP");
    }
    return this._changeDefaultActiveStep("Convite");
  }

  private _changeDefaultActiveStep(novoValor) {
    this.modalService.changeDefaultActiveStepLabel(novoValor);
  }

  onChangeStep(step: Step) {
    this.activeStepLabel = step.label;
  }

  onShowAndamentoCertificacao() {
    this.showAndamentoCertificacao = !this.showAndamentoCertificacao;
  }

  toggleModalStatus(modalStatus: boolean) {
    this.modalAberto = modalStatus;

    if (!this.modalAberto) {
      return this._desmontar();
    }

    this._inicializar();
  }

  onConcluirVCP() {
    this._inicializar();
    this.etapaTrocada.emit();
    window.location.reload();
  }
}
